import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f7f592"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-countdown"
}
const _hoisted_2 = { class: "m-countdown-title" }
const _hoisted_3 = { class: "m-countdown-clock" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Days", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hours", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Minutes", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Seconds", -1))
const _hoisted_8 = {
  key: 1,
  class: "m-countdown-pending"
}

import { computed } from "@vue/runtime-core";
import { SalePhase } from "@manifoldxyz/collectible-sdk";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'Countdown',
  setup(__props) {

const store = useStore();
const countdown = computed(() => {
  const countdown = store.mintCountdown;

  if (typeof countdown === "string") {
    throw new Error("Programmer error: `countdown` should not be a string");
  }

  return countdown;
});
const activeCountdown = computed(() => {
  return (
    [
      SalePhase.TO_CLAIM,
      SalePhase.CLAIM,
      SalePhase.TO_PRESALE,
      SalePhase.TO_PUBLIC_SALE,
      SalePhase.PRESALE,
      SalePhase.PUBLIC_SALE,
    ].indexOf(store.salePhase!) >= 0
  );
});
const messaging = useMessaging();
const countdownTypeText = computed(() => {
  let retval;
  const salePhase = store.salePhase;

  if (salePhase === SalePhase.TO_CLAIM) {
    retval = messaging.SALE_PHASE_CLAIM_START;
  } else if (salePhase === SalePhase.CLAIM) {
    retval = messaging.SALE_PHASE_CLAIM_END;
  } else if (salePhase === SalePhase.TO_PRESALE) {
    retval = messaging.SALE_PHASE_TO_PRESALE;
  } else if (salePhase === SalePhase.TO_PUBLIC_SALE) {
    retval = messaging.SALE_PHASE_TO_PUBLIC_SALE;
  } else if (salePhase === SalePhase.PRESALE) {
    retval = messaging.SALE_PHASE_IN_PRESALE;
  } else if (salePhase === SalePhase.PUBLIC_SALE) {
    retval = messaging.SALE_PHASE_IN_PUBLIC_SALE;
  } else if (salePhase === SalePhase.EXPIRED) {
    retval = messaging.SALE_PHASE_EXPIRED;
  } else if (salePhase === SalePhase.DEACTIVATED) {
    retval = messaging.SALE_PHASE_NOT_ACTIVE;
  } else {
    retval = "Loading";
  }

  return retval;
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(activeCountdown))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(countdownTypeText)) + " ", 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _hoisted_4,
                  _createElementVNode("p", null, _toDisplayString(_unref(countdown).days), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("p", null, _toDisplayString(_unref(countdown).hours), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createElementVNode("p", null, _toDisplayString(_unref(countdown).minutes), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("p", null, _toDisplayString(_unref(countdown).seconds), 1)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(_unref(countdownTypeText)), 1)
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})